module.exports = __webpack_public_path__ + "img/skills.e85bc0c3.svg";